import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChartPie = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M6.75 2.415A8.252 8.252 0 0 0 10 18.25a8.252 8.252 0 0 0 7.585-5M9.75 1.75c4.556 0 8.5 3.944 8.5 8.5h-8.5v-8.5Z"
	})]
});
const ForwardRef = forwardRef(SvgChartPie);
export { ForwardRef as ReactComponent };
